import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Box,
  Button,
  SelectChangeEvent,
  FormLabel,
  ToggleButtonGroup,
  ToggleButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  ListItem,
  CardContent,
  Card,
  List,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { Close, PersonAdd, Search } from "@mui/icons-material";
import AddUserDialog from "./addUserDialog";
import RequestUserDialog from "./requestCallbackDialoge";
import { useTranslation } from "react-i18next";
import AddUserTable from "./addUserTable";
import { toast } from "react-toastify";
import {
  AccountTypes,
  LocationClassList,
  LocationListData,
  SearchUserDetails,
  UsersList,
  EditUsersList,
  UserDetails,
} from "../../types/types";
import { axiosInstance } from "../../utils/tokenSetCookie";
import { AxiosError } from "axios";
import LoginRestriction from "../../utils/loginRestriction";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

const accountType: AccountTypes[] = [
  {
    id: 1,
    userAccessId: 1,
    tagName: "Doctor",
  },
];

interface Plan {
  title: string;
  price: string;
  request: string;
  icon: JSX.Element;
  features: { label: string; included: boolean }[];
}

const plans: Plan[] = [
  {
    title: "User Add-ons",
    price: "$49.99",
    request: "add-ons",
    icon: <PersonAdd sx={{ fontSize: 50 }} />,
    features: [
      { label: "Add 4 more users", included: true },
      { label: "Add-ons to your base subscription", included: true },
      { label: "Access all features", included: true },
    ],
  },
  {
    title: "More Users",
    price: "$---",
    icon: <PersonAdd sx={{ fontSize: 50 }} />,
    request: "callback",
    features: [
      { label: "Add more users", included: true },
      { label: "Scalable user access", included: true },
      { label: "Premium add-ons ", included: true },
      { label: "Priority support & full feature access", included: true },
    ],
  },
];
const ManagerUser = () => {
  const { t } = useTranslation();

  const [deletedList, setDeletedList] = useState("false");
  const [locationClassLists, setLocationClassLists] = useState<
    LocationClassList[]
  >([]);
  const [locationDataLists, setLocationDataLists] = useState<
    LocationListData[]
  >([]);
  const [usersList, setUsersList] = useState<UsersList[]>([]);
  const [locationClassName, setLocationClassName] = useState("0");
  const [locationName, setLocationName] = useState("0");
  const [isAccountType, setAccountType] = useState("0");
  const [openDialog, setOpenDialog] = useState(false);
  const [openCallbackDialog, setOpenCallbackDialog] = useState(false);
  const [editUserDetail, setEditUserDetail] = useState<EditUsersList | null>(
    null
  );
  const [dialogMode, setDialogMode] = useState<"add" | "edit">("add");
  const [userName, setUserName] = useState("");
  const [isDeletedLocation, setDeletedLocation] = useState<number>(0);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [userStatus, setUserStatus] = useState("false");
  const [userDetails, setUserDetails] = useState<UserDetails | null>(null);
  const [isSubscriptionDialogOpen, setIsSubscriptionDialogOpen] =
    useState(false);
  const [isRestrictionOpen, setIsRestrictionOpen] = useState(false);
  const [userLimit, _setUserLimit] = useState(0);

  const [loading, setLoading] = useState(false);

  // Simulate a 3-second loading period
  useEffect(() => {
    if (loading === true) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [loading]);

  // Getting location lists
  useEffect(() => {
    const getUserDetail = async () => {
      try {
        const response = await axiosInstance.get(
          API_BASE_URL + "users/getuserdetails"
        );
        if (response.status >= 200 && response.status <= 300) {
          setUserDetails(response.data.data); // Save data to state
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    getUserDetail(); // Passing the payload as an argument
  }, []);

  // Location and Location class lists API call
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [locationResponse, classResponse] = await Promise.all([
          axiosInstance.get(API_BASE_URL + "location/list/"),
          axiosInstance.get(API_BASE_URL + "locationclass/list"),
        ]);
        if (locationResponse.status >= 200 && locationResponse.status <= 300) {
          setLocationDataLists(locationResponse.data.data);
        }
        if (classResponse.status >= 200 && classResponse.status <= 300) {
          setLocationClassLists(classResponse.data.data);
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    fetchData();
  }, []);

  // Getting location under users
  useEffect(() => {
    const payload = {
      businessEntityId: 1,
      locationId: 1,
    };
    const fetchData = async (payload: any) => {
      try {
        const usersResponse = await axiosInstance.post(
          API_BASE_URL + "users/manage-user",
          payload
        );

        if (usersResponse.status >= 200 && usersResponse.status <= 300) {
          setUsersList(usersResponse.data.data);
        }
      } catch (error) {
        const errCode = error as AxiosError<{ status: number }>;
        if (errCode.response && errCode.response.status === 401) {
          setIsRestrictionOpen(true);
        } else {
          toast.error("Something went wrong", {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
          });
        }
        throw error;
      }
    };
    fetchData(payload);
  }, []);

  //  Getting location under users
  useEffect(() => {
    if (userStatus === "true") {
      const fetchUpdatedUsers = async () => {
        const payload = {
          businessEntityId: Number(userDetails?.userBusinessEntityId),
          locationId: locationName === "0" ? 0 : Number(locationName),
          isDeleted: deletedList === "true" ? 1 : 0,
          userName: userName,
          classId:
            locationClassName === "0" ? "" : locationClassName.toString(),
          accountAccessType: "",
        };

        try {
          const response = await axiosInstance.post(
            API_BASE_URL + "users/manage-user",
            payload
          );
          if (response.status >= 200 && response.status <= 300) {
            setUsersList(response.data.data);
            // Reset status after successful refresh
            setUserStatus("false");
          }
        } catch (error) {
          const errCode = error as AxiosError<{ status: number }>;
          if (errCode.response && errCode.response.status === 401) {
            setIsRestrictionOpen(true);
          } else {
            toast.error("Something went wrong", {
              position: "top-right",
              autoClose: 1000,
              hideProgressBar: false,
              closeOnClick: false,
              pauseOnHover: false,
              draggable: false,
              progress: undefined,
            });
          }
          throw error;
        }
      };

      fetchUpdatedUsers();
    }
  }, [
    userStatus,
    userDetails,
    locationName,
    deletedList,
    userName,
    locationClassName,
  ]);

  // Handle deleted list change event in Toggle button
  const handleChange = (
    _event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null
  ) => {
    if (newAlignment !== null) {
      setDeletedList(newAlignment);
    }
  };

  // Handle location class change event
  const handleLocationClassChange = (e: SelectChangeEvent) => {
    setLocationClassName(e.target.value);
  };
  // Handle location change event
  const handleLocationChange = (e: SelectChangeEvent) => {
    setLocationName(e.target.value);
  };
  // Handle account type change
  const handleAccountTypeChange = (e: SelectChangeEvent) => {
    setAccountType(e.target.value);
  };

  // Handle edit
  const handleEdit = async (userId: number) => {
    try {
      const response = await axiosInstance.get(
        `${API_BASE_URL}users/${userId}`
      );
      if (response.status >= 200 && response.status <= 300) {
        setEditUserDetail(response.data.data);
        setDialogMode("edit");
        setOpenDialog(true);
      } else {
        toast.error("Failed to fetch user details");
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
      throw error;
    }
  };

  // Handle delete dialog
  const handleDelete = (locationId: number) => {
    setIsDeleteDialogOpen(true);
    setDeletedLocation(locationId);
  };

  // Handle search function for location under users
  const handleSearch = async () => {
    const payload: SearchUserDetails = {
      businessEntityId: Number(userDetails?.userBusinessEntityId),
      locationId: locationName === "0" ? 0 : Number(locationName),
      isDeleted: deletedList === "true" ? 1 : 0,
      userName: userName,
      classId: locationClassName === "0" ? "" : locationClassName.toString(),
      accountAccessType: "",
    };

    try {
      const response = await axiosInstance.post(
        API_BASE_URL + "users/manage-user",
        payload
      );
      if (response.status >= 200 && response.status <= 300) {
        setUsersList(response.data.data);
        setLoading(true);
      } else {
        setUsersList([]);
        return toast.error(response.data.message, { autoClose: 1000 });
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
      throw error;
    }
  };

  // Handle dialog open and close
  const handleCloseDialog = () => setOpenDialog(false);
  // Handle callback dialog open and close
  const handleCloseCallbackDialog = () => setOpenCallbackDialog(false);

  const handleCloseSubscriptionDialog = () => {
    setIsSubscriptionDialogOpen(false);
  };

  // Handle dialog open and close
  const handleOpenDialog = (mode: "add" | "edit") => {
    if (mode === "add" && userLimit === 0) {
      setIsSubscriptionDialogOpen(true);
    } else {
      setDialogMode(mode);
      setOpenDialog(true);
    }
  };

  const closeDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  // Delete location data by id function
  const DeleteLocationData = async (userDelete: number) => {
    try {
      const response = await axiosInstance.delete(
        API_BASE_URL + `users/${userDelete}`
      );
      if (response.status >= 200 && response.status <= 300) {
        setIsDeleteDialogOpen(false);
        setUsersList((prev) => prev.filter((loc) => loc.id !== userDelete));
        return toast.success("User deleted successfully!", {
          autoClose: 500,
        });
      }
    } catch (error) {
      const errCode = error as AxiosError<{ status: number }>;
      if (errCode.response && errCode.response.status === 401) {
        setIsRestrictionOpen(true);
      } else {
        toast.error("Something went wrong", {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
          progress: undefined,
        });
      }
      throw error;
    }
  };


  const requestCallback = () => {
    setOpenCallbackDialog(true);
  };

  return (
    <>
      <Box sx={{ padding: { xs: 1, sm: 2 } }}>
        {/* First section - Search Form */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            margin: {
              xs: "10px 8px",
              sm: "15px 15px",
              md: "20px 20px",
            },
            overflow: "hidden",
          }}
        >
          <Typography
            variant="h5"
            sx={{
              borderBottom: "1px solid #eee",
              padding: "20px 24px",
              fontWeight: 600,
              color: "primary.main",
            }}
          >
            {t("manage_users")}
          </Typography>

          {/* Update form container spacing */}
          <form>
            <Grid
              container
              spacing={3}
              sx={{
                padding: { xs: 2, sm: 3 },
                "& .MuiFormLabel-root": {
                  marginBottom: 1,
                  color: "text.secondary",
                  fontWeight: 500,
                },
              }}
            >
              {/* Row 1: Business Entity & Location Class Name */}
              <Grid container item xs={12} spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <FormLabel className="formlabel">
                    {t("business_entity")}
                  </FormLabel>
                  <TextField
                    className="location_form_field"
                    value={userDetails?.businessName}
                    size="small"
                    variant="outlined"
                    fullWidth
                    InputProps={{
                      readOnly: true,
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <FormLabel
                      sx={{
                        color: "text.secondary",
                        fontSize: "0.875rem",
                        marginBottom: 1,
                      }}
                    >
                      {t("location_class_name")}
                    </FormLabel>
                    <Select
                      value={locationClassName}
                      onChange={handleLocationClassChange}
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "#e0e0e0",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          borderColor: "primary.main",
                        },
                        borderRadius: "8px",
                      }}
                    >
                      <MenuItem value="0">-- All --</MenuItem>
                      {locationClassLists.map((location) => (
                        <MenuItem key={location.id} value={location.id}>
                          {location.className}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Row 2: Location Name & Account Type */}
              <Grid container item xs={12} spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <FormLabel className="addUserformlabel">
                      {t("location_name")}
                    </FormLabel>
                    <Select
                      value={locationName}
                      onChange={handleLocationChange}
                      size="small"
                    >
                      <MenuItem value="0">-- All --</MenuItem>
                      {locationDataLists.map((location) => (
                        <MenuItem key={location.id} value={location.id}>
                          {location.locationName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormControl fullWidth>
                    <FormLabel className="addUserformlabel">
                      {t("account_type")}
                    </FormLabel>
                    <Select
                      value={isAccountType}
                      onChange={handleAccountTypeChange}
                      size="small"
                    >
                      <MenuItem value="">-- All --</MenuItem>
                      {accountType.map((list) => (
                        <MenuItem
                          key={list.userAccessId}
                          value={list.userAccessId}
                        >
                          {list.tagName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>

              {/* Row 3: Username & Switch */}
              <Grid container item xs={12} spacing={2} alignItems="center">
                <Grid item xs={12} md={6}>
                  <FormLabel className="formlabel">{t("username")}</FormLabel>
                  <TextField
                    name="textFieldValue"
                    value={userName}
                    onChange={(e) => setUserName(e.target.value)}
                    variant="outlined"
                    fullWidth
                    size="small"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        "& fieldset": {
                          borderColor: "#e0e0e0",
                        },
                        "&:hover fieldset": {
                          borderColor: "primary.main",
                        },
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={6} mt={3}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      flexWrap: "wrap",
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                      }}
                    >
                      <ToggleButtonGroup
                        color="primary"
                        value={deletedList}
                        exclusive
                        onChange={handleChange}
                        size="small"
                        sx={{
                          "& .MuiToggleButton-root": {
                            borderRadius: "6px",
                            px: 3,
                            "&.Mui-selected": {
                              backgroundColor: "primary.main",
                              color: "white",
                              "&:hover": {
                                backgroundColor: "primary.dark",
                              },
                            },
                          },
                        }}
                      >
                        <ToggleButton value="true">{t("on")}</ToggleButton>
                        <ToggleButton value="false">{t("off")}</ToggleButton>
                      </ToggleButtonGroup>
                      <Typography sx={{ color: "text.secondary" }}>
                        {t("view_deleted")}
                      </Typography>
                    </Box>

                    <Button
                      variant="contained"
                      sx={{
                        textTransform: "none",
                        borderRadius: "8px",
                        padding: "8px 24px",
                        backgroundColor: "primary.main",
                        "&:hover": {
                          backgroundColor: "primary.dark",
                        },
                      }}
                      startIcon={<Search />}
                      onClick={handleSearch}
                    >
                      {t("search")}
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </Box>

        {/* Second section - User Table */}
        <Box
          sx={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            margin: {
              xs: "10px 8px",
              sm: "15px 15px",
              md: "20px 20px",
            },
            padding: { xs: 1.5, sm: 2 },
          }}
        >
          {/* Add User button styling */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              mb: 3,
            }}
          >
            {/* Left Side Button */}
            <Box
              sx={{
                backgroundColor: userLimit ? "#1976d2" : "#ababab",
                padding: "7px",
                borderRadius: "5px",
                color: "#fff",
              }}
            >
              {userLimit ? (
                <Typography>
                  You are eligible to create up to {userLimit}{" "}
                  {userLimit === 1 ? "user" : "users"}.
                </Typography>
              ) : (
                <Typography>
                  User limit reached. Please upgrade your plan to add more users
                </Typography>
              )}
            </Box>

            {/* Right Side Button */}
            <Box>
              <Button
                onClick={() => handleOpenDialog("add")}
                variant="contained"
                sx={{
                  textTransform: "none",
                  borderRadius: "8px",
                  padding: "8px 24px",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  "&:hover": {
                    boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                  },
                }}
                startIcon={<PersonAdd />}
              >
                {t("add_user")}
              </Button>
            </Box>
          </Box>

          {/* Table container */}
          <Box
            sx={{
              border: "1px solid #eee",
              borderRadius: "8px",
              overflow: "hidden",
            }}
          >
            <AddUserTable
              users={usersList}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          </Box>
        </Box>

        <Dialog
          open={isDeleteDialogOpen}
          onClose={handleCloseDialog}
          sx={{
            "& .MuiDialog-paper": {
              width: { xs: "90%", sm: "500px" },
              borderRadius: "12px",
              padding: 2,
            },
          }}
        >
          <DialogTitle
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              pb: 1,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Delete User
            </Typography>
            <IconButton
              onClick={closeDeleteDialog}
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                border: "1px solid #be1e2d",
                color: "#be1e2d",
                transition: "all 0.2s",
                "&:hover": {
                  backgroundColor: "#be1e2d",
                  color: "#fff",
                },
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ py: 3 }}>
            <Typography>Are you sure you want to delete this user?</Typography>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={closeDeleteDialog}
              sx={{
                color: "text.secondary",
                "&:hover": {
                  backgroundColor: "grey.100",
                },
              }}
            >
              {t("no")}
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={() => DeleteLocationData(isDeletedLocation)}
              sx={{
                backgroundColor: "#be1e2d",
                "&:hover": {
                  backgroundColor: "#981824",
                },
              }}
            >
              {t("yes")}
            </Button>
          </DialogActions>
        </Dialog>

        <AddUserDialog
          openDialog={openDialog}
          onCloseDialog={handleCloseDialog}
          LocationClass={locationClassLists}
          Location={locationDataLists}
          AccountType={accountType}
          dialogMode={dialogMode}
          editData={editUserDetail}
          setStatus={setUserStatus}
        />
        <RequestUserDialog
          openDialog={openCallbackDialog}
          onCloseRequestDialog={handleCloseSubscriptionDialog}
          onCloseCallbackDialog={handleCloseCallbackDialog}
          userDetails={userDetails}
        />

        <Dialog
          open={isSubscriptionDialogOpen}
          onClose={() => setIsSubscriptionDialogOpen(false)}
          sx={{
            "& .MuiDialog-paper": {
              width: { xs: "90%", sm: "50%" },
              maxWidth: "100%",
              borderRadius: "12px",
            },
          }}
        >
          <DialogTitle
            sx={{
              pb: 1,
              borderBottom: "1px solid #eee",
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              User Upgrade Plans
            </Typography>
            <IconButton
              edge="end"
              color="inherit"
              onClick={() => setIsSubscriptionDialogOpen(false)}
              aria-label="close"
              sx={{
                position: "absolute",
                right: "25px",
                top: "17px",
                border: "1px solid #be1e2d",
                color: "#be1e2d",
                width: "30px",
                height: "30px",
                borderRadius: "50%",
                "&:hover": {
                  backgroundColor: "#be1e2d",
                  color: "#ffffff",
                },
              }}
            >
              <Close />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ pt: 3, marginTop: "15px" }}>
            <Typography sx={{ fontSize: "16px", mb: 2 }}>
              User limit reached. To add more users, please choose an upgrade
              plan: (Will be billed along with your base subscription).
            </Typography>

            <Box sx={{ py: 1 }}>
              <Grid container spacing={4} justifyContent="center">
                {plans.map((plan, index) => {
                  return (
                    <Grid item xs={12} sm={6} md={4} key={index}>
                      <Card
                        elevation={6}
                        sx={{
                          borderBottom: "10px solid #1976d2",
                          height: "100%",
                          "&:hover": {
                            transform: "translateY(-10px)",
                            transition: "transform 0.3s ease",
                            borderBottom: "10px solid #47d203",
                            background:
                              "linear-gradient(90deg,rgba(4, 98, 191, 1) 0%, rgba(0, 147, 191, 1) 100%);",
                            ".icon-wrapper": {
                              backgroundColor: "#fff", // Change icon color to white
                              color: "#1976d2",
                            },
                            ".icons, .title-wrapper, .text-wrapper": {
                              color: "#fff", // Change icon color to white
                            },
                            ".price-wrapper": {
                              color: "#fff",
                            },
                            ".button-wrapper": {
                              backgroundColor: "#fff",
                              color: "#1976d2",
                              fontWeight: "bold",
                            },
                          },
                        }}
                      >
                        <CardContent sx={{ textAlign: "center", pt: 3 }}>
                          <Box
                            mb={2}
                            className="icon-wrapper"
                            sx={{
                              color: "#fff",
                              backgroundColor: "#1976d2",
                              width: "max-content",
                              height: "max-content",
                              borderRadius: "50%",
                              justifyContent: "center",
                              alignItems: "center",
                              display: "flex",
                              margin: "0 auto",
                              padding: "10px",
                            }}
                          >
                            {plan.icon}
                          </Box>
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, mt: 2 }}
                            className="title-wrapper"
                          >
                            {plan.title}
                          </Typography>
                          <Typography
                            variant="h4"
                            sx={{
                              color: "#1976d2",
                              fontWeight: 700,
                              mt: 1,
                            }}
                            className="price-wrapper"
                          >
                            {plan.request === "callback" ? <></> : plan.price}
                          </Typography>
                          <List sx={{ mt: 1 }}>
                            {plan.features.map((feature, i) => (
                              <ListItem key={i} disablePadding>
                                <ListItemIcon sx={{ minWidth: 32 }}>
                                  {feature.included ? (
                                    <CheckCircleIcon
                                      className="icons"
                                      sx={{ color: "#2bd40f" }}
                                    />
                                  ) : (
                                    <CancelIcon
                                      className="icons"
                                      sx={{ color: "#e1137b" }}
                                    />
                                  )}
                                </ListItemIcon>
                                <ListItemText
                                  primary={feature.label}
                                  className="text-wrapper"
                                  sx={{ color: "#555" }}
                                />
                              </ListItem>
                            ))}
                          </List>
                          <Box mt={1}>
                            {plan.request === "callback" ? (
                              <Button
                                variant="contained"
                                className="button-wrapper"
                                sx={{
                                  backgroundColor: "#1976d2",
                                  "&:hover": {
                                    backgroundColor: "#36b39d",
                                  },
                                  borderRadius: 2,
                                  textTransform: "uppercase",
                                }}
                                onClick={requestCallback}
                              >
                                Request Callback
                              </Button>
                            ) : (
                              <Button
                                variant="contained"
                                className="button-wrapper"
                                sx={{
                                  backgroundColor: "#1976d2",
                                  "&:hover": {
                                    backgroundColor: "#36b39d",
                                  },
                                  borderRadius: 2,
                                  textTransform: "uppercase",
                                }}
                                onClick={() => toast.warning("Coming Soon !!")}
                              >
                                Buy Plan
                              </Button>
                            )}
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                })}
              </Grid>
            </Box>
          </DialogContent>

          
        </Dialog>

        <LoginRestriction open={isRestrictionOpen} />
      </Box>
    </>
  );
};

export default ManagerUser;
